import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { filter } from 'rxjs';

import { AppSharedModule } from '../../../../../../app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from '../../../../../../services/otel.service';
import { DocumentScoringMetricsSectionComponent } from '../document-scoring-metrics-section/document-scoring-metrics-section.component';
import { DocumentScoringPanel } from '../document-scoring-metrics.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-document-scoring-metrics-metricdata-section',
  imports: [AppSharedModule, DocumentScoringMetricsSectionComponent],
  templateUrl: './document-scoring-metrics-metricdata-section.component.html',
  styleUrl: './document-scoring-metrics-metricdata-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentScoringMetricsMetricdataSectionComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  panel = input<DocumentScoringPanel>();
  metrics = input<{ name: string; value: number }[]>([]);
  allowSorting = input(false);

  expandedChanged = output<DocumentScoringPanel>();

  displayColumns = ['name', 'value'];

  metricsDs = computed<MatTableDataSource<any>>(() => new MatTableDataSource(this.metrics()));

  sort = viewChild(MatSort);

  constructor() {
    toObservable(this.sort)
      .pipe(
        takeUntilDestroyed(),
        filter((s) => !!s && this.allowSorting())
      )
      .subscribe((sort) => {
        sort.active = 'name';
        sort.direction = 'asc';
        this.metricsDs().sort = sort;
      });
  }

  onExpandedChanged(panel: DocumentScoringPanel) {
    this.expandedChanged.emit(panel);
  }
}
